import { render, staticRenderFns } from "./EditAwards.vue?vue&type=template&id=06456fb6&"
import script from "./EditAwards.vue?vue&type=script&lang=js&"
export * from "./EditAwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports